import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicTable, TableFilter, EmptyState, BaasicButton, BasicQueryCheckbox } from 'core/components';
import EmptyIcon from 'themes/assets/img/building-modern.svg';
import { ApplicationListLayout, Content, PageNavigation } from 'core/layouts';
import { isSome } from 'core/utils';

function NikoCorporateListTemplate({ listViewStore }) {
    const {
        tableLoading,
        tableStore,
        basicQueryCheckboxStore,
        queryUtility,
        downloadContactsUrl,
        routes,
        authorization
    } = listViewStore;

    return (
        <ApplicationListLayout store={listViewStore}>
            <PageNavigation>
                <BaasicButton
                    authorization={authorization ? authorization.create : null}
                    className="btn btn--base btn--primary"
                    label='CORPORATE.LIST.BUTTON.CREATE'
                    onClick={() => routes.create()}>
                </BaasicButton>
                {downloadContactsUrl ? <a className="btn btn--base btn--primary u-mar--left--sml" href={downloadContactsUrl}><i className="u-icon u-icon--sml u-icon--download--white"></i>Download</a> : null}
            </PageNavigation>
            <Content emptyRenderer={renderEmpty()} >
                <div className='u-mar--bottom--sml'>
                    <TableFilter queryUtility={queryUtility}>
                    <div className="col form__group">
                        <label className="form__group__label">Select Corporates to Show</label>
                        <div>
                            <BasicQueryCheckbox id={'corporates'} queryUtility={queryUtility} propertyName={'isActive'} label={'Show inactive'} store={basicQueryCheckboxStore}/>
                        </div>
                    </div>
                    </TableFilter>
                </div>
                <div className="card--table">
                    <BaasicTable
                        tableStore={tableStore}
                        loading={tableLoading}
                        actionsComponent={renderActions}
                    />
                </div>
            </Content>
        </ApplicationListLayout>
    )
}

function renderEmpty() {
    return <EmptyState image={EmptyIcon} title='CORPORATE.LIST.EMPTY_STATE.TITLE' description='CORPORATE.LIST.EMPTY_STATE.DESCRIPTION' />
}

NikoCorporateListTemplate.propTypes = {
    listViewStore: PropTypes.object
};

function renderActions({item, actions, authorization}){
    if (!isSome(actions)) return null;

    const { onEdit, onPreview } = actions;
    if (!isSome(onEdit) && !isSome(onPreview)) return null;

    return (
        <td className="table__body--data right">
            <div className="table__icons">
                {isSome(onPreview) ? (
                    <BaasicButton
                        authorization={authorization ? authorization.read : null}
                        className="btn btn--icon"
                        icon='u-icon u-icon--preview u-icon--sml'
                        label='CORPORATE.LIST.BUTTON.PREVIEW'
                        onlyIcon={true}
                        onClick={() => onPreview(item)}>
                    </BaasicButton>
                ) : null}
                {isSome(onEdit) ? (
                    <BaasicButton
                        authorization={authorization ? authorization.update : null}
                        className="btn btn--icon"
                        icon='u-icon u-icon--edit u-icon--sml'
                        label='CORPORATE.LIST.BUTTON.EDIT'
                        onlyIcon={true}
                        onClick={() => onEdit(item)}>
                    </BaasicButton>
                ) : null}
            </div>
        </td>
    );

}

renderActions.propTypes = {
    item: PropTypes.object,
    actions: PropTypes.object,
    authorization: PropTypes.any
};

export default defaultTemplate(NikoCorporateListTemplate);
